export const ROUTES = [
  {
    name: 'my_portfolio',
    route: '/',
  },
  {
    name: 'main_account',
    route: '/main-account/',
  },
  {
    name: 'exchange',
    route: '/exchange/',
  },
  {
    name: 'dca_strategy',
    route: '/dca-strategy/',
  },
  {
    name: 'management_mandate',
    route: '/management-mandate/',
  },
  {
    name: 'rwa',
    route: '/rwa/',
  },
  {
    name: 'pricing',
    route: '/about-us/pricing/',
  },
  {
    name: 'our_story',
    route: '/about-us/our-story/',
  },
  {
    name: 'documentation',
    route: '/about-us/documentation/',
  },
  {
    name: 'terms_of_use',
    route: '/legal/terms-of-use/',
  },
  {
    name: 'legal_notices',
    route: '/legal/legal-notices/',
  },
  {
    name: 'cookie_management_policy',
    route: '/legal/cookie-management-policy/',
  },
  {
    name: 'user_preferences',
    route: '/user-preferences/',
  },
  {
    name: 'on_boarding',
    route: '/on-boarding/synaps/',
  },
  {
    name: 'on_boarding',
    route: '/on-boarding/survey/',
  },
  {
    name: 'on_boarding',
    route: '/on-boarding/management-mandate/',
  },
  {
    name: 'survey',
    route: '/survey/',
  },
]
